export default __webpack_public_path__ + "media/images/fx_factures_blue-b8898185f92244821ed4432253e013e3.png";